import { type ReleaseAttributes } from './generated/ReleaseAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';
import { HasCustomFieldValues } from './concerns/HasCustomFieldValues';
import { HasExtensionFields } from './concerns/HasExtensionFields';

interface Release extends ReleaseAttributes, HasCustomFieldValues {}

@model
@HasExtensionFields
@HasCustomFieldValues
class Release extends ApplicationModel {
  // Start auto-generated
  static typename: 'Release' = 'Release';
  get typename(): 'Release' {
    return 'Release';
  }

  static internalTypename: 'Release' = 'Release';
  get internalTypename(): 'Release' {
    return 'Release';
  }

  static terminologyName = 'Release';

  static inputType = 'ReleaseAttributes!';

  static filterType = 'ReleaseFilters!';
  static filters = {
    id: '[ID!]',
    projectId: 'ID',
    active: 'Boolean',
    parkingLot: 'Boolean',
    workflowStatusInternalMeanings: '[InternalMeaning!]',
    hasDevelopmentStartedOn: 'Boolean',
  };

  static fields = {
    capacityUnits: attr({ readable: true }),
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    daysToRelease: attr({ readable: true }),
    developmentStartedOn: attr({ writable: true, readable: true }),
    endOn: attr({ readable: true }),
    epicsCount: attr({ readable: true }),
    externalReleaseDate: attr({ readable: true }),
    featuresCount: attr({ readable: true }),
    goalsCount: attr({ readable: true }),
    id: attr({ readable: true }),
    initiativesCount: attr({ readable: true }),
    integrationLinksCount: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    parkingLot: attr({ readable: true }),
    path: attr({ readable: true }),
    position: attr({ readable: true }),
    progress: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    releaseDate: attr({ writable: true, readable: true }),
    releasePhasesCount: attr({ readable: true }),
    releasedOn: attr({ readable: true }),
    startOn: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    watchersCount: attr({ readable: true }),
    workflowStatusId: attr({ readable: true }),
    owner: attr.belongsTo({ readable: true, typename: 'User' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Project',
    }),
    researchFolder: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Page',
    }),
    terminology: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    theme: attr.belongsTo({ readable: true, typename: 'Note' }),
    workflowStatus: attr.belongsTo({
      writeShape: ['id', 'name', 'category'],
      readable: true,
      typename: 'WorkflowStatus',
    }),
    addGoals: attr.hasMany({ writable: true, readable: false }),
    addInitiatives: attr.hasMany({ writable: true, readable: false }),
    childRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    comments: attr.hasMany({ readable: true }),
    customFieldValues: attr.hasMany({
      args: { ids: '[ID!]', keys: '[String!]' },
      readable: true,
    }),
    epics: attr.hasMany({ readable: true }),
    extensionFields: attr.hasMany({
      args: { filters: 'ExtensionFieldFilters' },
      readable: true,
    }),
    features: attr.hasMany({ readable: true }),
    goals: attr.hasMany({ writable: true, readable: true }),
    initiatives: attr.hasMany({ writable: true, readable: true }),
    integrationLinks: attr.hasMany({ readable: true }),
    parentRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    releasePhases: attr.hasMany({ readable: true }),
    removeGoals: attr.hasMany({ writable: true, readable: false }),
    removeInitiatives: attr.hasMany({ writable: true, readable: false }),
    tasks: attr.hasMany({ readable: true }),
    watchers: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  get scheduledReleaseDate() {
    return this.parkingLot ? null : this.releaseDate;
  }

  get statusText() {
    return this.workflowStatus?.name;
  }
}

export default Release;
